import { useState } from 'react';

import {
  Text,
  Tooltip,
  type TooltipProps,
  type TextProps,
} from '@frontend/components';
import { useHasTextOverflow } from '@frontend/utils';

const ELLIPSIS_PROPS = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export type TruncateTextWithTooltipProps = {
  text: string;
  displayText?: string;
  tooltipProps?: Omit<TooltipProps, 'children'>;
} & TextProps;

export const InnerTruncateTextWithTooltip = ({
  text,
  displayText = text,
  tooltipProps,
  ...restProps
}: TruncateTextWithTooltipProps) => {
  const [textEl, setTextEl] = useState(null);
  const showTooltip = useHasTextOverflow(textEl);

  return (
    <Tooltip
      label={text}
      isDisabled={!showTooltip}
      variant="expanded"
      {...tooltipProps}
    >
      <Text
        fontFamily="data"
        {...ELLIPSIS_PROPS}
        ref={setTextEl}
        {...restProps}
      >
        {displayText}
      </Text>
    </Tooltip>
  );
};

export const TruncateTextWithTooltip = (
  props: TruncateTextWithTooltipProps,
) => <InnerTruncateTextWithTooltip {...props} key={props.text} />;
